/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { Auth0Plugin } from "./auth0-plugin";
import i18n from './i18n'

// import validations from "@/mixins/validations";
// Vue.mixin(validations)

import './plugins/index'

import CardLoadingTransparent from "./components/shared/CardLoadingTransparent";
import CardLoadingTransparentLinear from "./components/shared/CardLoadingTransparentLinear";
import CardLoading from "./components/shared/CardLoading";
import DialogLoading from "./components/shared/DialogLoading";
import BasePageTitle from "./components/shared/base_components/BasePageTitle";
import BaseCard from "./components/shared/base_components/BaseCard";
import FDialog from "./components/shared/base_components/FDialog";
import FButton from "./components/shared/base_components/FButton";
import BaseInfoCard from "./components/shared/base_components/BaseInfoCard";
import BaseInfoCardMarker from "./components/shared/base_components/BaseInfoCardMarker";
import BaseInfoCardDotMarker from "./components/shared/base_components/BaseInfoCardDotMarker";
import BaseBreadcrumb from "./components/shared/base_components/BaseBreadcrumb";
import SortFilterTable from './components/shared/sort_filter_table/SortFilterTable.vue';
import DatePicker from "./components/shared/DatePicker";

Vue.component("dialog-loading", DialogLoading);
Vue.component("card-loading", CardLoading);
Vue.component("card-loading-transparent", CardLoadingTransparent);
Vue.component("card-loading-transparent-linear", CardLoadingTransparentLinear);
Vue.component("base-page-title", BasePageTitle);
Vue.component("base-card", BaseCard);
Vue.component("f-dialog", FDialog);
Vue.component("f-btn", FButton);

Vue.component("base-info-card", BaseInfoCard);
Vue.component("base-info-card-marker", BaseInfoCardMarker);
Vue.component("base-info-card-dot-marker", BaseInfoCardDotMarker);

Vue.component("base-breadcrumb", BaseBreadcrumb);
Vue.component("sort-filter-table", SortFilterTable);
Vue.component("date-picker", DatePicker);

import ProjectSmallCard from "./components/shared/ProjectSmallCard";
Vue.component("project-small-card", ProjectSmallCard);

import TaskSmallCard from "./components/shared/TaskSmallCard";
Vue.component("task-small-card", TaskSmallCard);

Vue.config.productionTip = false;

console.log(process.env);

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetPath
        ? appState.targetPath
        : window.location.pathname
    );
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
/* eslint-enable */
